import { Redirect, Route } from "react-router";
import useAuth from "../../hooks/use-auth";

const PrivateRoute = ({ component: Component, ...rest }) => {
  //   const data = fetchLocalData("vidamaze_user");
  //   const dispatch = useDispatch();

  //   const isLogin = () => {
  //     if (data?.id) {
  //       const { exp } = jwt_decode(data.token);

  //       // console.log(exp)
  //       const expirationTime = exp * 1000 - 60000;
  //       if (Date.now() >= expirationTime) {
  //         // localStorage.clear();
  //         // history.push("/login");
  //         return false;
  //       } else {
  //         dispatch(authActions.login({ token: data.token }));
  //         return true;
  //         // console.log(isAuthenticated, "akash");
  //       }
  //     } else {
  //       return false;
  //     }
  //   };
  const { isLogin } = useAuth();
  // console.log("rest", rest);

  return (
    // Show the component only when the user is logged in
    // Otherwise, redirect the user to /login page
    <Route
      {...rest}
      render={(props) =>
        isLogin() ? <Component {...props} /> : <Redirect to="/login" />
      }
    />

    // <Route
    //   {...rest}
    //   render={(props) => {
    //     if (!isLogin()) {
    //       // not logged in so redirect to login page with the return url
    //       return (
    //         <Redirect
    //           to={{ pathname: "/login", state: { from: props.location } }}
    //         />
    //       );
    //     }

    //     // check if route is restricted by role
    //     if (rest.user_roles && rest.user_roles.role_id === 1) {
    //       // role not authorised so redirect to home page
    //       console.log("Calling Second");

    //       return <Redirect to="/" />;
    //     }

    //     // authorised so return component
    //     console.log("Calling first");
    //     return <Component {...props} />;
    //   }}
    // />
  );
};

export default PrivateRoute;
